import { createFileRoute } from "@tanstack/react-router";

import { routeHead } from "@/lib/seo-head";
import Contact from "@/pages/Contact";

export const Route = createFileRoute("/contact")({
  head: () =>
    routeHead({
      path: '/contact',
      title: "Contact | JIIA Studio Architecte d'intérieur Lyon",
      description: "Contactez JIIA Studio pour votre projet d'architecture d'intérieur en Rhône-Alpes. Réponse sous 48h, premier rendez-vous offert.",
    }),
  component: Contact,
});
